import type { ReactElement } from "react";
import { memo } from "react";

import type { TIconProps } from "../types";

// NOTE: NSAI-7339 — Zoho Mail's product mark (without the wordmark) from Zoho's
// own asset (zohowebstatic.com/sites/zweb/images/productlogos/mail.svg), in the
// brand colours #226db4 (hsl 209 68% 42%) and #f9b21d (hsl 41 95% 55%), each
// tinted from its own hue like the other integration icons. The square viewBox
// is centred on the mark's bounding box.
const ZohoMailComponent = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="2.4 -0.1 296.0 296.0"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="hsl(from hsl(41 95% 55%) h s 55%)"
      d="M235.4,198.6c-4.7,0-8.5-3.8-8.5-8.5v-46.2c0-4.8-3.9-8.7-8.7-8.7H82.6c-4.8,0-8.7,3.9-8.7,8.7v9.7 c0,4.7-3.8,8.5-8.5,8.5c-4.7,0-8.5-3.8-8.5-8.5v-9.7c0-14.1,11.5-25.7,25.7-25.7h135.6c14.1,0,25.7,11.5,25.7,25.7v46.2 C243.9,194.8,240.1,198.6,235.4,198.6z"
    />
    <path
      fill="hsl(from hsl(209 68% 42%) h s 42%)"
      d="M269.7,292.9H31.1c-14.1,0-25.7-11.5-25.7-25.7v-67.8c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v67.8 c0,4.8,3.9,8.7,8.7,8.7h238.6c4.8,0,8.7-3.9,8.7-8.7V123.4c0-2.7-1.2-5.1-3.3-6.8L155.8,21.9c-3.2-2.5-7.6-2.5-10.8,0L25.7,116.6 c-2.1,1.6-3.3,4.1-3.3,6.8v29.1c0,3.2,1.8,6.1,4.6,7.7l119.3,63.5c2.6,1.4,5.6,1.4,8.2,0l76.9-41c4.1-2.2,9.3-0.6,11.5,3.5 c2.2,4.1,0.6,9.3-3.5,11.5l-76.9,41c-7.6,4-16.6,4-24.1,0L19,175.1c-8.4-4.5-13.6-13.2-13.6-22.7v-29.1c0-7.9,3.6-15.2,9.7-20.1 L134.4,8.6c4.5-3.6,10.2-5.6,16-5.6l0,0c5.8,0,11.4,2,16,5.6l119.3,94.7c6.2,4.9,9.7,12.2,9.7,20.1v143.9 C295.4,281.4,283.9,292.9,269.7,292.9z"
    />
  </svg>
);

// NOTE: Memoized per the repo's mandatory-memoization rule for exported
// components.
export const ZohoMail = memo(ZohoMailComponent);
